export default __webpack_public_path__ + "static/aboutus4-cff1e1795578a0304419894bc6b91967.png";